import { mdlAgencyDetailRequest } from "../models/service-models/agency/AgencyDetailRequest";
import { mdlAgencyDetailResponse } from "../models/service-models/agency/AgencyDetailResponse";
import { mdlAgencyListByPaxIdRequest } from "../models/service-models/agency/AgencyListByPaxIdRequest";
import { mdlAgencyListByPaxIdResponse } from "../models/service-models/agency/AgencyListByPaxIdResponse";
import { mdlAgencyListRequest } from "../models/service-models/agency/AgencyListRequest";
import { mdlAgencyListResponse } from "../models/service-models/agency/AgencyListResponse";
import { mdlAgencyUpdateRequest } from "../models/service-models/agency/AgencyUpdateRequest";
import { mdlAgencyUpdateResponse } from "../models/service-models/agency/AgencyUpdateResponse";
import { mdlSendConnectionRequestMailRequest } from "../models/service-models/agency/SendConnectionRequestMailRequest";
import { mdlSendConnectionRequestMailResponse } from "../models/service-models/agency/SendConnectionRequestMailResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { GetResponse } from "../utils/ApiClient";

namespace AgencyService {
    export async function List(
        pRequest: mdlAgencyListRequest
    ): Promise<mdlServiceResponse<mdlAgencyListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyListResponse>>(
            "agency/list",
            pRequest
        );
    }
    export async function Detail(
        pRequest: mdlAgencyDetailRequest
    ): Promise<mdlServiceResponse<mdlAgencyDetailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyDetailResponse>>(
            "agency/detail",
            pRequest
        );
    }
    export async function Update(
        pRequest: mdlAgencyUpdateRequest
    ): Promise<mdlServiceResponse<mdlAgencyUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyUpdateResponse>>(
            "agency/toggle-connection",
            pRequest
        );
    }
    export async function ListByPaxId(
        pRequest: mdlAgencyListByPaxIdRequest
    ): Promise<mdlServiceResponse<mdlAgencyListByPaxIdResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyListByPaxIdResponse>>(
            "agency/list-by-pax-id",
            pRequest
        );
    }
    export async function SendConnectionRequestMail(
        pRequest: mdlSendConnectionRequestMailRequest
    ): Promise<mdlServiceResponse<mdlSendConnectionRequestMailResponse>> {
        return await GetResponse<mdlServiceResponse<mdlSendConnectionRequestMailResponse>>(
            "agency/send-connection-request-mail",
            pRequest
        );
    }
}
export { AgencyService };
